<app-navbar></app-navbar>

<section class="blog-details-area pb-100" style="
background-image: url('assets/img/banner-image/bg.png');  
/* background-size: cover; */

 /* background-repeat: repeat-y; */
padding-top: 20px;
font-family: 'Congenial';">
    <div class="container" style="background: transparent;">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="blog-details-desc text-center" style="background-image: url('/assets/img/school/bg-popup.png');
          background-size: 100px;padding: 20px; padding-top: 10px; padding-bottom: 10px;  border: 1px solid #eeeeee;">
                    <div class="article-image">
                        <h2 style="font-weight: normal;">
                            Photo
                        </h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container" style="background: transparent;">
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-blog-post">
                    <div>
                        <a routerLink="/photo"><img src="/assets/img/photos/2.jpg" alt="image"></a>
                    </div>
                    <div style="padding: 25px;">
                        <div>
                            <ul style="padding-left: 0;
                            margin-bottom: 0;
                            list-style-type: none;">
                                <li style="display: inline-block;
                                margin-right: 15px;
                                font-size: 15px;">December 21, 2023</li>
                            </ul>
                        </div>
                        <h3><a routerLink="/photo">Gallery 1</a></h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-blog-post">
                    <div>
                        <a routerLink="/photo"><img src="assets/img/photos/3.jpg" alt="image"></a>
                    </div>
                    <div style="padding: 25px;">
                        <div>
                            <ul style="padding-left: 0;
                            margin-bottom: 0;
                            list-style-type: none;">
                                <li style="display: inline-block;
                                margin-right: 15px;
                                font-size: 15px;">December 21, 2023</li>
                            </ul>
                        </div>
                        <h3><a routerLink="/photo">Gallery 2</a></h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-blog-post">
                    <div>
                        <a routerLink="/photo"><img src="/assets/img/photos/5.jpg" alt="image"></a>
                    </div>
                    <div style="padding: 25px;">
                        <div>
                            <ul style="padding-left: 0;
                            margin-bottom: 0;
                            list-style-type: none;">
                                <li style="display: inline-block;
                                margin-right: 15px;
                                font-size: 15px;">December 21, 2023</li>
                            </ul>
                        </div>
                        <h3><a routerLink="/photo">Gallery 3</a></h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-blog-post">
                    <div>
                        <a routerLink="/photo"><img src="/assets/img/photos/6.jpg" alt="image"></a>
                    </div>
                    <div style="padding: 25px;">
                        <div>
                            <ul style="padding-left: 0;
                            margin-bottom: 0;
                            list-style-type: none;">
                                <li style="display: inline-block;
                                margin-right: 15px;
                                font-size: 15px;">December 21, 2023</li>
                            </ul>
                        </div>
                        <h3><a routerLink="/photo">Gallery 4</a></h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-blog-post">
                    <div>
                        <a routerLink="/photo"><img src="/assets/img\photos/7.jpg" alt="image"></a>
                    </div>
                    <div style="padding: 25px;">
                        <div>
                            <ul style="padding-left: 0;
                            margin-bottom: 0;
                            list-style-type: none;">
                                <li style="display: inline-block;
                                margin-right: 15px;
                                font-size: 15px;">December 21, 2023</li>
                            </ul>
                        </div>
                        <h3><a routerLink="/photo">Gallery 4</a></h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-blog-post">
                    <div>
                        <a routerLink="/photo"><img src="/assets/img/photos/8.jpg" alt="image"></a>
                    </div>
                    <div style="padding: 25px;">
                        <div>
                            <ul style="padding-left: 0;
                            margin-bottom: 0;
                            list-style-type: none;">
                                <li style="display: inline-block;
                                margin-right: 15px;
                                font-size: 15px;">December 21, 2023</li>
                            </ul>
                        </div>
                        <h3><a routerLink="/photo">Gallery 4</a></h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-blog-post">
                    <div>
                        <a routerLink="/photo"><img src="/assets/img/photos/9.jpg" alt="image"></a>
                    </div>
                    <div style="padding: 25px;">
                        <div>
                            <ul style="padding-left: 0;
                            margin-bottom: 0;
                            list-style-type: none;">
                                <li style="display: inline-block;
                                margin-right: 15px;
                                font-size: 15px;">December 21, 2023</li>
                            </ul>
                        </div>
                        <h3><a routerLink="/photo">Gallery 4</a></h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-blog-post">
                    <div>
                        <a routerLink="/photo"><img src="/assets/img/photos/11.jpg" alt="image"></a>
                    </div>
                    <div style="padding: 25px;">
                        <div>
                            <ul style="padding-left: 0;
                            margin-bottom: 0;
                            list-style-type: none;">
                                <li style="display: inline-block;
                                margin-right: 15px;
                                font-size: 15px;">December 21, 2023</li>
                            </ul>
                        </div>
                        <h3><a routerLink="/photo">Gallery 4</a></h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-blog-post">
                    <div>
                        <a routerLink="/photo"><img src="/assets/img/photos/12.jpg" alt="image"></a>
                    </div>
                    <div style="padding: 25px;">
                        <div>
                            <ul style="padding-left: 0;
                            margin-bottom: 0;
                            list-style-type: none;">
                                <li style="display: inline-block;
                                margin-right: 15px;
                                font-size: 15px;">December 21, 2023</li>
                            </ul>
                        </div>
                        <h3><a routerLink="/photo">Gallery 4</a></h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-blog-post">
                    <div>
                        <a routerLink="/photo"><img src="/assets/img/photos/14.jpg" alt="image"></a>
                    </div>
                    <div style="padding: 25px;">
                        <div>
                            <ul style="padding-left: 0;
                            margin-bottom: 0;
                            list-style-type: none;">
                                <li style="display: inline-block;
                                margin-right: 15px;
                                font-size: 15px;">December 21, 2023</li>
                            </ul>
                        </div>
                        <h3><a routerLink="/photo">Gallery 4</a></h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-blog-post">
                    <div>
                        <a routerLink="/photo"><img src="/assets/img/photos/15.jpg" alt="image"></a>
                    </div>
                    <div style="padding: 25px;">
                        <div>
                            <ul style="padding-left: 0;
                            margin-bottom: 0;
                            list-style-type: none;">
                                <li style="display: inline-block;
                                margin-right: 15px;
                                font-size: 15px;">December 21, 2023</li>
                            </ul>
                        </div>
                        <h3><a routerLink="/photo">Gallery 4</a></h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-blog-post">
                    <div>
                        <a routerLink="/photo"><img src="/assets/img/photos/16.jpg" alt="image"></a>
                    </div>
                    <div style="padding: 25px;">
                        <div>
                            <ul style="padding-left: 0;
                            margin-bottom: 0;
                            list-style-type: none;">
                                <li style="display: inline-block;
                                margin-right: 15px;
                                font-size: 15px;">December 21, 2023</li>
                            </ul>
                        </div>
                        <h3><a routerLink="/photo">Gallery 4</a></h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-blog-post">
                    <div>
                        <a routerLink="/photo"><img src="/assets/img/photos/17 March 2023 pic smc.jpg" alt="image"></a>
                    </div>
                    <div style="padding: 25px;">
                        <div>
                            <ul style="padding-left: 0;
                            margin-bottom: 0;
                            list-style-type: none;">
                                <li style="display: inline-block;
                                margin-right: 15px;
                                font-size: 15px;">December 21, 2023</li>
                            </ul>
                        </div>
                        <h3><a routerLink="/photo">Gallery 4</a></h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-blog-post">
                    <div>
                        <a routerLink="/photo"><img src="/assets/img/photos/17.jpg" alt="image"></a>
                    </div>
                    <div style="padding: 25px;">
                        <div>
                            <ul style="padding-left: 0;
                            margin-bottom: 0;
                            list-style-type: none;">
                                <li style="display: inline-block;
                                margin-right: 15px;
                                font-size: 15px;">December 21, 2023</li>
                            </ul>
                        </div>
                        <h3><a routerLink="/photo">Gallery 4</a></h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-blog-post">
                    <div>
                        <a routerLink="/photo"><img src="/assets/img/photos/20.jpg" alt="image"></a>
                    </div>
                    <div style="padding: 25px;">
                        <div>
                            <ul style="padding-left: 0;
                            margin-bottom: 0;
                            list-style-type: none;">
                                <li style="display: inline-block;
                                margin-right: 15px;
                                font-size: 15px;">December 21, 2023</li>
                            </ul>
                        </div>
                        <h3><a routerLink="/photo">Gallery 4</a></h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-blog-post">
                    <div>
                        <a routerLink="/photo"><img src="/assets/img/photos/21.jpg" alt="image"></a>
                    </div>
                    <div style="padding: 25px;">
                        <div>
                            <ul style="padding-left: 0;
                            margin-bottom: 0;
                            list-style-type: none;">
                                <li style="display: inline-block;
                                margin-right: 15px;
                                font-size: 15px;">December 21, 2023</li>
                            </ul>
                        </div>
                        <h3><a routerLink="/photo">Gallery 4</a></h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-blog-post">
                    <div>
                        <a routerLink="/photo"><img src="/assets/img/photos/22.jpg" alt="image"></a>
                    </div>
                    <div style="padding: 25px;">
                        <div>
                            <ul style="padding-left: 0;
                            margin-bottom: 0;
                            list-style-type: none;">
                                <li style="display: inline-block;
                                margin-right: 15px;
                                font-size: 15px;">December 21, 2023</li>
                            </ul>
                        </div>
                        <h3><a routerLink="/photo">Gallery 4</a></h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-blog-post">
                    <div>
                        <a routerLink="/photo"><img src="/assets/img/photos/23.jpg" alt="image"></a>
                    </div>
                    <div style="padding: 25px;">
                        <div>
                            <ul style="padding-left: 0;
                            margin-bottom: 0;
                            list-style-type: none;">
                                <li style="display: inline-block;
                                margin-right: 15px;
                                font-size: 15px;">December 21, 2023</li>
                            </ul>
                        </div>
                        <h3><a routerLink="/photo">Gallery 4</a></h3>
                    </div>
                </div>
                <div class="single-blog-post">
                    <div>
                        <a routerLink="/photo"><img src="/assets/img/photos/26 March 2023 pic, SMC.jpg" alt="image"></a>
                    </div>
                    <div style="padding: 25px;">
                        <div>
                            <ul style="padding-left: 0;
                            margin-bottom: 0;
                            list-style-type: none;">
                                <li style="display: inline-block;
                                margin-right: 15px;
                                font-size: 15px;">December 21, 2023</li>
                            </ul>
                        </div>
                        <h3><a routerLink="/photo">Gallery 4</a></h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>